var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.hide),expression:"hide",arg:"tap"}],staticClass:"wallpaper",style:(("margin-left: " + _vm.marginLeft + "px;z-index: " + _vm.zIndex))},[_c('img',{staticClass:"wallpaper-img",attrs:{"src":_vm.pic}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563753ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/WallpaperPreviewerImage.vue
// module id = null
// module chunks = 